import React, { useEffect, useState } from "react";
import { TrendingUp, ChevronRight } from "lucide-react";
import api, { TRY } from "@/lib/api";
import { Card } from "@/components/Cards";

export default function CostAlertBanner({ goTo }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/costs/alerts").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data || data.count === 0) return null;
  return (
    <Card className="p-4 border-rose-500/40 bg-rose-500/5" data-testid="cost-alert-banner">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 rounded-lg bg-rose-500/15 text-rose-500 flex items-center justify-center shrink-0"><TrendingUp className="h-5 w-5" /></div>
          <div>
            <div className="font-heading font-semibold text-rose-500">{data.count} maliyet sınıfı önceki aya göre %{data.threshold}'den fazla arttı</div>
            <div className="text-sm text-muted-foreground mt-0.5 flex flex-wrap gap-1.5">
              {data.alerts.map((a) => (
                <span key={a.category} data-testid={`cost-alert-${a.category}`} className="rounded-md bg-card/70 border border-border px-2 py-0.5 text-xs">
                  {a.name}: <span className="font-mono text-rose-500">+{a.pct}%</span> <span className="font-mono">({TRY(a.previous)} → {TRY(a.current)})</span>
                </span>
              ))}
            </div>
          </div>
        </div>
        <button onClick={() => goTo && goTo("costs")} data-testid="cost-alert-goto" className="text-sm font-semibold text-primary inline-flex items-center gap-1 hover:underline">Maliyetlere git <ChevronRight className="h-4 w-4" /></button>
      </div>
    </Card>
  );
}
